<template>
  <div>
    <el-button icon="el-icon-refresh" @click="$refresh(getFormulaStatistics)" class="refresh-btn">刷新</el-button>
    <div class="wrap count">
      <!-- 条件查询 -->
      <div class="search">
        <el-form :inline="true" :model="searchForm">
          <el-form-item label="医馆名称">
            <el-select v-model="searchForm.deptIds" multiple placeholder="请选择医馆名称">
              <el-option v-for="item in deptOptions" :key="item.value"  :label="item.label" :value="item.value"/>
            </el-select>
          </el-form-item>
          <el-form-item label="月份">
            <el-date-picker v-model="searchForm.date" value-format="yyyy-MM" type="monthrange" align="right"
            unlink-panels range-separator="至" start-placeholder="开始月份" end-placeholder="结束月份"
            :picker-options="pickerOptions" @change="val => $setDates(val, getFormulaStatistics)"/>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="$refresh(getFormulaStatistics, true)">查询</el-button>
            <el-button icon="el-icon-refresh" @click="$reset(getFormulaStatistics, { deptIds: [], dates: [], date: null })">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
      <!-- 操作按钮 -->
      <div class="button">
        <el-button @click="$exportSummary(searchForm, '/report/export/repice', '员工配方统计')"
          icon="el-icon-download" type="primary">导出报表</el-button>
      </div>
      <!-- 员工配方列表 -->
      <el-table v-loading="loading" :data="formulaStatisticsList" :max-height="tableHeight" border>
        <el-table-column fixed prop="name" min-width="70" label="员工姓名"/>
        <el-table-column label="原药配方数据">
          <el-table-column  label="处方张数(张)" min-width="110">
            <template slot-scope="scope">{{scope.row.recipeRawMaterial.recipeNumber}}</template>
          </el-table-column>
          <el-table-column  label="配方付数(付)" min-width="110">
            <template slot-scope="scope">{{scope.row.recipeRawMaterial.recipeDoseNumber}}</template>
          </el-table-column>
          <el-table-column  label="配方味数(味)" min-width="110">
            <template slot-scope="scope">{{scope.row.recipeRawMaterial.recipeDrugNumber}}</template>
          </el-table-column>
        </el-table-column>
        <el-table-column label="免煎配方数据">
          <el-table-column  label="处方张数(张)" min-width="110">
            <template slot-scope="scope">{{scope.row.recipeExemption.recipeNumber}}</template>
          </el-table-column>
          <el-table-column  label="配方付数(付)" min-width="110">
            <template slot-scope="scope">{{scope.row.recipeExemption.recipeDoseNumber}}</template>
          </el-table-column>
          <el-table-column  label="配方味数(味)" min-width="110">
            <template slot-scope="scope">{{scope.row.recipeExemption.recipeDrugNumber}}</template>
          </el-table-column>
        </el-table-column>
        <el-table-column label="加工配方数据">
          <el-table-column  label="处方张数(张)" min-width="110">
            <template slot-scope="scope">{{scope.row.recipeDecotion.recipeNumber}}</template>
          </el-table-column>
          <el-table-column  label="配方付数(付)" min-width="110">
            <template slot-scope="scope">{{scope.row.recipeDecotion.recipeDoseNumber}}</template>
          </el-table-column>
          <el-table-column  label="配方味数(味)" min-width="110">
            <template slot-scope="scope">{{scope.row.recipeDecotion.recipeDrugNumber}}</template>
          </el-table-column>
        </el-table-column>
        <el-table-column label="审方数(个)" min-width="90" prop="auditNumber"/>
        <el-table-column label="复核数(个)" min-width="90" prop="recheckNumber"/>
        <el-table-column label="打包数(个)" min-width="90" prop="packagingNumber"/>
      </el-table>
      <!-- 分页 -->
      <el-pagination @current-change="page => $handleCurrentChange(page, getFormulaStatistics)"
      :current-page="currentPage" :page-size="pageSize" layout="total, prev, pager, next, jumper" :total="total"/>
    </div>
  </div>
</template>

<script lang="js">
import { formulaStatistics } from "@/api/statement"; // 报表统计请求
export default {
  name: 'StaffFormula',
  data() {
    return {
      loading: false, // 加载中
      searchForm: { deptIds: [], dates: [], date: null }, // 查询表单
      formulaStatisticsList: [], // 员工配方统计列表
      currentPage: 1, // 当前页
      pageSize: 10, // 显示条数
      total: 0, // 总条数
      deptOptions: this.$session.get('options'), // 医馆列表
      pickerOptions:{ // 排班日期可选范围
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
        shortcuts: this.$shortcuts
      },
      tableHeight: 0, // 表格最大高度
    };
  },
  created() {
    this.tableHeight = document.documentElement.clientHeight - 330;
    this.$forceUpdate();
    this.$setCurMonth(this.getFormulaStatistics);
  },
  methods: {
    // 请求所有员工配方统计列表
    async getFormulaStatistics() {
      let { rows, code, total } = await formulaStatistics(this.currentPage, this.pageSize, this.searchForm);
      if (code == 200) {
        this.formulaStatisticsList = rows;
        this.total = total;
      }
      this.loading = false;
    }
  },
};
</script>